import React, {useState} from 'react';

import AudioPlayer from "../../../../AudioPlayer";
import imgSquare from '../../../../../img/icon-arrow-up-right-from-square.svg'
import imgMp from '../../../../../img/icon-mp32.png'
import '../../ProjectsFiles.scss';

const LinkItem = ({projectLink}) => {
    const [isAudioPlayerVisible, setAudioPlayerVisible] = useState(false);

    const handleAudioButtonClick = () => {
        setAudioPlayerVisible(!isAudioPlayerVisible);
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = projectLink.url;
        link.download = projectLink.title;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

   let fileItemContent = (
       <div className="file-item">
           <a href={projectLink.url} target="blank" rel="noreferrer">
               <div className="icon icon-play">
                   <img src={imgSquare} alt={projectLink.title}/>
               </div>
           </a>
           <button onClick={handleDownload}>{projectLink.title}</button>
       </div>
    );

    if (projectLink.url.endsWith(".mp3")) {
        fileItemContent = (
            <div className="file-item">
                <a href={projectLink.url} target="blank" rel="noreferrer" onClick={(e) => e.preventDefault()}>
                    <div className="icon icon-play">
                        <img src={imgMp} alt={projectLink.title}/>
                    </div>
                </a>
                <button onClick={handleAudioButtonClick}>{projectLink.title}</button>
                {isAudioPlayerVisible && <AudioPlayer src={projectLink.url} />}
            </div>
        );
    }

    return fileItemContent
}

export default LinkItem;
